import { CommonModule } from '@angular/common';
import { Component, Inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, Observable, of, switchMap } from 'rxjs';
import { CRMApiService, CrmObject } from '@vendasta/crm';
import { MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/meeting-analysis/static';
import { map } from 'rxjs/operators';
import { RouterModule } from '@angular/router';
import { ParticipantComponent } from './participant/participant.component';
import { AttendeeComponent } from '../attendees/attendee/attendee.component';

interface ContactContainer {
  contact: CrmObject | null;
  contactId: string;
}

@Component({
  selector: 'meeting-analysis-participants',
  imports: [CommonModule, RouterModule, ParticipantComponent, AttendeeComponent],
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.scss'],
})
export class ParticipantsComponent {
  contactIds = input<string[]>([]);
  large = input<boolean>(false);
  contactContainers$ = combineLatest([this.namespace$, toObservable(this.contactIds)]).pipe(
    switchMap(([namespace, contactIds]) => {
      if (contactIds.length === 0) {
        return of({ contactIds: [] as string[], contacts: [] as (CrmObject | null)[] });
      }
      return this.contactService
        .getMultiContact({
          namespace: namespace,
          crmObjectIds: contactIds,
        })
        .pipe(map((response) => ({ contactIds, contacts: response?.crmObjects || [] })));
    }),
    map(({ contactIds, contacts }) => {
      const contactMap = new Map(contacts.filter((c): c is CrmObject => c !== null).map((c) => [c.crmObjectId, c]));
      const containers = contactIds.map(
        (contactId) =>
          ({
            contact: contactMap.get(contactId) || null,
            contactId,
          }) as ContactContainer,
      );
      return containers.sort((a, b) => (a.contact === null ? 1 : 0) - (b.contact === null ? 1 : 0));
    }),
  );

  constructor(
    private readonly contactService: CRMApiService,
    @Inject(MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$) private readonly namespace$: Observable<string>,
  ) {}
}
